import type { Vendor } from '@pedestal-panels/contracts';

/**
 * Catalogue of panels currently navigable through the exhibition app.
 *
 * Order mirrors Phase 1 in the bootstrap brief. Adding a panel here makes it
 * appear in the topbar selector and routable via `#/panels/<vendor>/<id>`;
 * the panel package itself must still be installed and register its custom
 * element under the conventional tag name `<panel-<id>>`.
 */

export interface PanelEntry {
  readonly id: string;
  readonly vendor: Vendor;
  readonly model: string;
  readonly productName: string;
  readonly phase: 1 | 2 | 3 | 4 | 5;
}

export const phase1Panels: readonly PanelEntry[] = [
  {
    id: 'rcp-3500',
    vendor: 'sony',
    model: 'RCP-3500',
    productName: 'Sony RCP-3500',
    phase: 1,
  },
  {
    id: 'msu-3000',
    vendor: 'sony',
    model: 'MSU-3000',
    productName: 'Sony MSU-3000',
    phase: 1,
  },
  {
    id: 'mcp-400',
    vendor: 'grassvalley',
    model: 'MCP-400',
    productName: 'Grass Valley MCP-400',
    phase: 1,
  },
  {
    id: 'ocp-400',
    vendor: 'grassvalley',
    model: 'OCP-400',
    productName: 'Grass Valley OCP-400',
    phase: 1,
  },
  {
    id: 'cgp-500',
    vendor: 'grassvalley',
    model: 'CGP-500',
    productName: 'Grass Valley CGP-500',
    phase: 1,
  },
];
